import {TemplateVariable} from '../../../generated/graphql';
import {isSingleVarString} from '../DefaultResourceConfig/defaultResourceConfigUtil';
import {JsonObject} from '../utilTypes';

export const substituteVariables = (
  config: JsonObject,
  variables: Record<string, number | string>
): JsonObject => {
  function injectVarsIntoString(str: string): string | number {
    let singleValue: string | number | null = null;
    const replaceString = str.replace(/\{\{(\w+)\}\}/g, (match, varName) => {
      singleValue = variables[varName];
      return variables[varName]?.toString() ?? match;
    });
    if (isSingleVarString(str) && singleValue != null) {
      return singleValue;
    }
    return replaceString;
  }

  function substitute(obj: any): any {
    if (typeof obj === 'string') {
      return injectVarsIntoString(obj);
    } else if (typeof obj === 'number') {
      return obj;
    } else if (Array.isArray(obj)) {
      return obj.map(item => substitute(item));
    } else if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, val]) => [key, substitute(val)])
      );
    }
    return obj;
  }

  return substitute(config);
};

export const getDefaultVariableValuesFromQueueVariables = (
  variables: TemplateVariable[]
) => {
  const z = variables.reduce((acc, variable) => {
    const parsedSchema = JSON.parse(variable.schema);
    return {
      ...acc,
      ...(parsedSchema.default != null && {
        [variable.name]: parsedSchema.default,
      }),
    };
  }, {});
  return z;
};
